import * as React from 'react'
import { useCallback, useContext, useEffect, useState } from 'react'
import GridContainer from '../grid/GridContainer'
import GridItem from '../grid/GridItem'
import axios from 'axios'
import { apiUrl, UserContext } from '../../App'
import MaterialTable from 'material-table'
import download from 'downloadjs'
import Backdrop from '@material-ui/core/Backdrop'
import CircularProgress from '@material-ui/core/CircularProgress'
import { getApiUrl } from '../../api/api'

const columns = [
  { title: 'Referat', field: 'department', width: '10%' },
  {
    title: 'Motivation',
    field: 'motivation',
    width: '70%',
    render: (rowData) => <span style={{ whiteSpace: 'pre-line' }}> {rowData.motivation} </span>,
  },
  { title: 'Bewohner', field: 'tenantName', width: '10%' },
  {
    title: 'Email',
    field: 'tenantEmail',
    render: (rowData) => <a href={`mailto:${rowData.tenantEmail}`}> {rowData.tenantEmail} </a>,
    width: '10%',
  },
]

export default function HeimratEngagementApplication() {
  const { user } = useContext(UserContext)

  const [applications, setApplications] = useState([])

  const [proceeding, setProceeding] = useState(true)

  const fetchApplications = useCallback(() => {
    setProceeding(true)
    getApiUrl()
      .get(`/api/engagements/applications`)
      .then(function (response) {
        setProceeding(false)
        setApplications(response.data)
      })
      .catch(function (error) {
        setProceeding(false)
        console.log(error)
      })
  }, [])

  const downloadImage = (rowData) => {
    axios
      .get(`${apiUrl}/api/engagements/applications/${rowData.applicationId}/image`, {
        headers: { Authorization: `Bearer ${user.token}`, 'X-Smartdorm-Dorm-ID': '4885b6d1-bbe4-4d40-bd24-bce33f0d7728' },
        responseType: 'blob',
      })
      .then((response) => {
        const content = response.headers['content-type']
        const fileName = response.headers['x-file-name']
        download(response.data, fileName, content)
      })
      .catch((error) => console.log(error))
  }

  useEffect(() => {
    fetchApplications()
  }, [fetchApplications])

  if (proceeding) {
    return (
      <Backdrop open={proceeding}>
        <CircularProgress color="inherit" />
      </Backdrop>
    )
  }

  return (
    <GridContainer>
      <GridItem xs={12} sm={12} md={12}>
        <MaterialTable
          columns={columns}
          data={applications}
          title="Bewerbungen für Referate und Ämter"
          actions={[
            (rowData) => {
              return !rowData.hasImage
                ? { hidden: true }
                : {
                    tooltip: 'Das Bild herunterladen',
                    icon: 'download',
                    hidden: false,
                    onClick: (event, rowData) => {
                      downloadImage(rowData)
                      event.stopPropagation()
                    },
                  }
            },
          ]}
          options={{
            pageSize: 10,
            pageSizeOptions: [10, 30, 50],
            headerStyle: {
              fontWeight: 600,
            },
            exportButton: true,
          }}
          localization={{
            pagination: {
              labelDisplayedRows: '{from}-{to} von {count}',
              labelRowsSelect: 'Einträge',
              labelRowsPerPage: 'Zeilen pro Seite',
            },
            toolbar: {
              nRowsSelected: '{0} Zeile(n) ',
              searchPlaceholder: 'Suchen',
              searchTooltip: 'Suchen',
            },
            header: {
              actions: 'Aktion',
            },
            body: {
              emptyDataSourceMessage: 'Keine Bewerbungen',
              filterRow: {
                filterTooltip: 'Filter',
              },
            },
          }}
        />
      </GridItem>
    </GridContainer>
  )
}
